/**
 * src/api/copilot.ts
 * -------------------
 * Ask Copilot — the top-bar assistant.
 *
 * Endpoint:
 *   POST /copilot/ask  → { answer, grounded_in }
 *
 * The backend assembles a snapshot of the org's live state (active
 * conversations, 24h sentiment split, top intents, unresolved alerts) and asks
 * the org's configured `agent` model about it, so answers reflect the console
 * rather than the model's general knowledge.
 *
 * Depends on: src/api/client.ts
 */
import apiClient from './client'

export interface CopilotMessage {
  role: 'user' | 'assistant'
  content: string
}

export interface CopilotAnswer {
  answer: string
  /** The state snapshot the answer was grounded in — handy for debugging. */
  grounded_in: Record<string, unknown>
}

export async function askCopilot(
  question: string,
  history: CopilotMessage[] = [],
): Promise<CopilotAnswer> {
  const { data } = await apiClient.post<CopilotAnswer>('/copilot/ask', {
    question,
    history,
  })
  return data
}
